var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper",class:{ 'is-active': _vm.loading }},[_c('div',{staticClass:"loader is-loading"})])}
var staticRenderFns = []

export { render, staticRenderFns }